import { ButtonClickSource } from 'state/amplitude/constants';
import { OrderLocatorTab } from 'state/launchdarkly/variations';

const orderHereButtonClickSourceByTab: Partial<Record<OrderLocatorTab, ButtonClickSource>> = {
  [OrderLocatorTab.NEARBY]: ButtonClickSource.STORE_SELECTOR_NEARBY_TAB,
  [OrderLocatorTab.FAVORITE]: ButtonClickSource.STORE_SELECTOR_FAVORITES_TAB,
  [OrderLocatorTab.RECENT]: ButtonClickSource.STORE_SELECTOR_RECENTS_TAB,
};

export const getOrderHereButtonClickSource = ({
  isInSupportForm,
  tab,
}: {
  isInSupportForm?: boolean;
  tab: OrderLocatorTab;
}) => {
  if (isInSupportForm) {
    return undefined;
  }

  return orderHereButtonClickSourceByTab[tab];
};
